// components/BenefitsFilters.jsx
import React from 'react';
import { ageCategory, ageCategoryKitchen, benefitCategory, shortnames, shortnames_kitch } from '../constants/benefits';
import { getBenefitsLists } from '../helpers/benefitsHelpers';
import '../StatisticaBenefits.css';

const { benefits_kg, benefits_kitch } = getBenefitsLists(shortnames, shortnames_kitch);

const BenefitsFilters = ({
  years,
  distr,
  selYear,
  selDist,
  selCategory,
  selAge,
  selPilgaKg,
  period,
  periods,
  onYearChange,
  onDistrictChange,
  onCategoryChange,
  onAgeChange,
  onBenefitChange,
  onPeriodChange,
  onShowData
}) => {
  const currentAgeCategory = selCategory === 'kg' ? ageCategory : ageCategoryKitchen;
  const currentBenefits = selCategory === 'kg' ? benefits_kg : benefits_kitch;

  return (
    <div className="filter-row">
      <div className="row">
        <div className="col-md-2 filter-section">
          <label className="filter-label">Навчальний рік:</label>
          <select 
            className="filter-select" 
            value={selYear} 
            onChange={onYearChange}
          >
            {years.map((elem, index) => (
              <option key={index} value={`${elem._id}:${index}`}>
                {elem._id}/{elem._id + 1}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">Район:</label>
          <select 
            className="filter-select" 
            value={selDist} 
            onChange={onDistrictChange}
          >
            {distr.map((dist, index) => (
              <option key={index} value={dist}>{dist}</option>
            ))}
            <option value='all'>всі райони</option>
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">Дія пільг:</label>
          <select 
            className="filter-select" 
            value={selCategory} 
            onChange={onCategoryChange}
          >
            {benefitCategory.map((b, index) => (
              <option key={index} value={b.v}>{b.t}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">Вікова категорія:</label>
          <select 
            className="filter-select" 
            value={selAge} 
            onChange={onAgeChange}
          >
            {currentAgeCategory.map((age, index) => (
              <option key={index} value={age.v}>{age.t}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">Пільга:</label>
          <select 
            className="filter-select" 
            value={selPilgaKg} 
            onChange={onBenefitChange}
          >
            {currentBenefits.map((ben, index) => (
              <option key={index} value={ben.id}>{ben.name}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">Станом на:</label>
          <select 
            className="filter-select" 
            value={period} 
            onChange={onPeriodChange}
          >
            {periods.map((p, index) => (
              <option key={index} value={p}>{p}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">&nbsp;</label>
          <button className="filter-button" onClick={onShowData}>
            Показати
          </button>
        </div>
      </div>
    </div>
  );
};

export default BenefitsFilters;